"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uuid = require("uuid");

var constants = _interopRequireWildcard(require("@paprika/constants/lib/Constants"));

var _helpers = require("@paprika/helpers");

var _Check = _interopRequireDefault(require("@paprika/icon/lib/Check"));

var _Dash = _interopRequireDefault(require("@paprika/icon/lib/Dash"));

var _CheckboxInputPropsCollector = _interopRequireDefault(require("./CheckboxInputPropsCollector"));

var types = _interopRequireWildcard(require("./types"));

var sc = _interopRequireWildcard(require("./Checkbox.styles"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var Checkbox = function Checkbox(props) {
  var a11yText = props.a11yText,
      children = props.children,
      isDisabled = props.isDisabled,
      checkedState = props.checkedState,
      size = props.size,
      onChange = props.onChange,
      tabIndex = props.tabIndex,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "children", "isDisabled", "checkedState", "size", "onChange", "tabIndex"]);

  var _React$useState = _react["default"].useState(function () {
    return "checkbox_".concat((0, _uuid.v4)());
  }),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 1),
      checkboxId = _React$useState2[0];

  var inputRef = _react["default"].useRef(null);

  var extendedInputProps = (0, _helpers.extractChildrenProps)(children, _CheckboxInputPropsCollector["default"]);

  _react["default"].useEffect(function () {
    if (!inputRef.current) return;

    if (checkedState === types.checkboxStates.INDETERMINATE) {
      inputRef.current.indeterminate = types.checkboxStates.INDETERMINATE;
    } else {
      inputRef.current.indeterminate = false;
    }
  }, [checkedState]);

  var styleProps = {
    hasLabel: !!children,
    size: size
  };

  var inputProps = _objectSpread(_objectSpread({
    checked: checkedState === types.checkboxStates.CHECKED,
    disabled: isDisabled,
    onChange: onChange,
    ref: inputRef,
    tabIndex: tabIndex,
    type: "checkbox"
  }, extendedInputProps), {}, {
    id: checkboxId
  });

  if (a11yText) inputProps["aria-label"] = a11yText;
  return /*#__PURE__*/_react["default"].createElement(sc.Checkbox, (0, _extends2["default"])({
    "data-pka-anchor": "checkbox"
  }, styleProps, moreProps), /*#__PURE__*/_react["default"].createElement("input", inputProps), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: checkboxId
  }, children, /*#__PURE__*/_react["default"].createElement(_Check["default"], {
    className: "checkbox-icon",
    "aria-hidden": true,
    "data-pka-anchor": "checkbox.icon.check"
  }), /*#__PURE__*/_react["default"].createElement(_Dash["default"], {
    "aria-hidden": true,
    className: "checkbox-icon",
    "data-pka-anchor": "checkbox.icon.indeterminate"
  })));
};

Checkbox.types = {
  size: constants.defaultSize,
  state: types.checkboxStates
};

var noop = function noop() {};

var propTypes = {
  /** Used for aria-label on the checkbox input  */
  a11yText: _propTypes["default"].string,

  /** The checkbox state */
  checkedState: _propTypes["default"].oneOf([Checkbox.types.state.CHECKED, Checkbox.types.state.UNCHECKED, Checkbox.types.state.INDETERMINATE]),

  /** Used for label contents */
  children: _propTypes["default"].node,

  /** Describe if the checkbox is disabled or not */
  isDisabled: _propTypes["default"].bool,

  /** Callback triggered when the input state is changed */
  onChange: _propTypes["default"].func,

  /** Size provided by parent Group component */
  size: _propTypes["default"].oneOf([Checkbox.types.size.SMALL, Checkbox.types.size.MEDIUM, Checkbox.types.size.LARGE]),

  /** Value for tabindex attribute to override the default of 0. */
  tabIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
};
var defaultProps = {
  a11yText: null,
  checkedState: Checkbox.types.state.UNCHECKED,
  children: null,
  isDisabled: false,
  onChange: noop,
  size: Checkbox.types.size.MEDIUM,
  tabIndex: 0
};
Checkbox.displayName = "Checkbox";
Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;
Checkbox.Input = _CheckboxInputPropsCollector["default"];
var _default = Checkbox;
exports["default"] = _default;
//# sourceMappingURL=Checkbox.js.map